export const CREATE_UTILISATEUR = {
  title: 'Créer un collaborateur',
  racine: 'Accueil',
  parametrage: 'Paramétrage',
  createCollaborateur: 'Créer un collaborateur',
  editCollaborateur: 'Modifier collaborateur {nomPrenom}',
  listeCollaborateur: 'Liste des collaborateurs',
  editSuccess: 'Modification du collaborateur réalisée avec succès',
  ajoutSuccess: 'Création du collaborateur réalisée avec succès',
  onglet: {
    collaborateur: 'Collaborateur',
    societeAgence: 'Sociétés et agences',
    role: 'Rôles',
    secteur: 'Secteurs',
    service: 'Services',
  },
  actions: {
    etapeSuivante: 'Etape suivante',
    etapePrecedente: 'Etape précédente',
    cancel: 'Annuler',
  },
  steps: {
    first: {
      title: 'Etape 1',
      sousTitle: 'Informations sur le collaborateur',
    },
    second: {
      title: 'Etape 2',
      sousTitle: 'Société(s) & Agence(s)',
    },
    third: {
      title: 'Etape 3',
      sousTitle: 'Rôle(s)',
    },
    fourth: {
      title: 'Etape 4',
      sousTitle: 'Service(s)',
    },
  },
};

export const UTILISATEUR_FIRST_STEP = {
  infosUtilisateur: {
    title: 'Informations du collaborateur',
    civilite: 'Civilité',
    nom: 'Nom',
    prenom: 'Prénom',
    email: 'Email',
    tel: 'Téléphone',
    agence: 'Agence de rattachement principale',
    profil: 'Profil',
    regieExterne: 'Régie externe',
    estTechnicien: 'Technicien',
    estTechnicienToolTip: 'L\'utilisateur pourra être affecté à un ot technique',
    estAfficheur: 'Afficheur',
    estAfficheurToolTip: 'L\'utilisateur pourra être affecté à un ot d\'affichage',
    responsableBail: 'Responsable bail',
  },
  identifiantConnexion: {
    title: 'Identifiant de connexion',
    identifiant: 'Identifiant',
    motDePasse: 'Mot de passe',
    confirmerMdp: 'Confirmer votre mot de passe',
    connexion: 'Connexion autorisée à Affixe2.0',
    caracMini: '6 caractères minium',
    incorrectMdp: 'Mots de passe différents',
    yes: 'Oui',
    no: 'Non',
    messagePassword: 'Le mot de passe doit contenir au moins 6 caractères et ne doit pas inclure les caractères suivants : [ ] { } ( ) \\ ^ $ . | ? * +',
  },
  signature: {
    title: 'Signature email',
  },
};

export const UTILISATEUR_SECOND_STEP = {
  title: 'Société & Agence',
  sousTitle: 'Sélectionner les sociétés/agences pour donner accès à votre collaborateur',
};

export const UTILISATEUR = {
  profil: {
    directeurCommercial: 'Directeur commercial',
    commercial: 'Commercial',
    assistantCommercial: 'Assistant commercial',
    autre: 'Autre',
    ancienGestionnaire: 'Ancien gestionnaire',
    ancienAssistantCommercial: 'Ancien assistant commercial',
  },
  warning: {
    utilisateurArchive: 'L\'utilisateur renseigné est actuellement archivé',
    utilisateursArchives: 'Les utilisateurs en orange sont actuellement archivés',
    responsableBailArchive: 'Le responsable du bail "{name}" est actuellement archivé',
    assistantArchive: 'L\'assistant "{name}" est actuellement archivé',
    validateurArchive: 'Le validateur "{name}" est actuellement archivé',
    validateursArchives: 'Les validateurs en orange sont actuellement archivés',
    commercialArchive: 'Le commercial "{name}" est actuellement archivé',
    declarantArchive: 'Le déclarant "{name}" est actuellement archivé',
    auditeurArchive: 'L\'auditeur "{name}" est actuellement archivé',
    demandeurArchive: 'Le demandeur "{name}" est actuellement archivé',
    contactExpediteurArchive: 'Le contact expéditeur "{name}" est actuellement archivé',
    utilisateurNameArchive: 'L\'utilisateur "{name}" est actuellement archivé',
    utilisateurDomaine: 'L\'utilisateur renseigné est lié à un portail',
  },
};

export const VALIDATION = {
  nom: 'Le champ \'nom\' est obligatoire',
  regieExterneMusBeCommercial: 'Un utilisateur régie externe doit avoir un rôle de commercial',
  agence: 'Le champ \'agence de rattachement principale\' est obligatoire',
  profil: 'Le champ \'profil\' est obligatoire',
  identifiant: 'Le champ \'identifiant\' est obligatoire',
  motPasse: 'Le champ \'mot de passe\' est obligatoire',
  role: 'Vous devez renseigner au moins un rôle',
  motPasseLength: 'Le mot de passe doit faire 6 caractères minimum',
  confMotPasse: 'Le mot de passe et la confirmation du mot de passe sont différents',
  userAlreadyTake: 'L\'identifiant est déjà utilisé',
  emailAlreadyTake: 'L\'email est déjà utilisé',
  agenceRattachementSelect: 'L\'agence de rattachament doit être aussi sélectionnée',
  emailNotValid: 'L\'adresse mail n\'est pas valide',
  identifiantWithArobase: 'L\'identifiant ne doit pas contenir de \'@\'',
  passwordNotValid: 'Le mot de passe contient des caractères non autorisés : [ ] { } ( ) \\ ^ $ . | ? * +',
  utiliseDansAffixe: 'Impossible de supprimer certains rôles pour cet utilisateur',
};
export const LISTE_UTILISATEUR = {
  title: 'Liste des collaborateurs',
  racine: 'Accueil',
  parametrage: 'Paramétrage',
  createCollaborateur: 'Créer un collaborateur',
  tab: {
    profil: 'Profil',
    identifiant: 'Identifiant',
    role: 'Rôle(s)',
    civilite: 'Civilité',
    nom: 'Nom',
    prenom: 'Prénom',
    tel: 'Téléphone',
    mail: 'Email',
  },
  actions: {
    search: 'Rechercher',
    utilisateurArchive: 'Afficher les collaborateurs archivés ({nbre})',
    masquerUtlisateurArchiver: 'Masquer les collaborateurs archivés ({nbre})',
    archiver: 'Archiver',
  },
  popUpArchivageDesarchivage: {
    titleArchivage: 'Etes-vous sûr de vouloir archiver cet utilisateur ?',
    titleDesarchivage: 'Etes-vous sûr de vouloir désarchiver cet utilisateur ?',
    success: {
      archivage: 'Utilisateur archivé avec succès.',
      desarchivage: 'Utilisateur désarchivé avec succès.',
    },
    infoArchivageDesarchivage: {
      archivage: 'L\'utilisateur archivé ne pourra plus se connecter à affixe 2.',
      desarchivage: 'Autoriser la connexion à affixe 2 ?',
    },

  },
};

export const UTILISATEUR_THIRD_STEP = {
  title: 'Rôles',
  noResult: 'Aucun résultat',
  sousTitle: 'Rôle(s) du collaborateur',
  placeholder: 'Choisissez un rôle pour votre collaborateur',
};

export const SECTEUR_UTILISATEUR = {
  title: 'Secteur',
  actions: {
    newSecteurUtilisateur: 'Ajouter un secteur',
  },
  liste: {
    secteur: 'Secteur',
    type: 'Type',
    actif: 'Actif',
    yes: 'Oui',
    no: 'Non',
  },
};

export const SERVICE_UTILISATEUR = {
  title: 'Service',
  actions: {
    addServiceUtilisateur: 'Ajouter un Service',
  },
  table: {
    code: 'Code',
    nomCommercial: 'Service',
    archive: 'Archivé',
  },
};

export const DETAIL_UTILISATEUR = {
  title: 'Détail collaborateur {nomPrenom}',
  informations: 'Informations',
  regieExterne: '- régie externe',
  technicien: 'Peut être utilisé en tant que technicien dans les OTs technique',
  afficheur: 'Peut être utilisé en tant qu\'afficheur dans les OTs d\'affichage',
  responsableBail: 'Responsable bail',
  tab: {
    commissions: 'Commissions',
    information: 'Informations',
    secteur: 'Secteurs',
  },
  role: 'Rôle(s)',
  roleDetail: 'Rôle(s) :',
  email: 'Email :',
  telephone: 'Téléphone :',
  agenceRattachement: 'Agence de rattachement principale :',
  listeAgence: 'Liste des agences',
  collaborateur: 'Collaborateur',
  listeService: 'Liste des services',
};
